"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basicOperators = void 0;
exports.basicOperators = {
    "$eq": (data, value) => {
        if (value === null) {
            // since JSON doesn't have undefined, we use null to represent undefined
            return data === null || data === undefined;
        }
        return data === value;
    },
    "$ne": (data, value) => {
        if (value === null) {
            // since JSON doesn't have undefined, we use null to represent undefined
            return data !== null && data !== undefined;
        }
        return data !== value;
    },
    "$in": (data, value) => {
        return Array.isArray(value) && value.includes(data);
    },
    "$nin": (data, value) => {
        return Array.isArray(value) && !value.includes(data);
    },
    "$exists": (data, value) => {
        switch (value) {
            case true:
                return data !== undefined;
            case false:
                return data === undefined;
            default:
                return false;
        }
    },
    "$regex": (data, value, options) => {
        if (data === null || data === undefined || typeof data !== "string") {
            return false;
        }
        const regexPattern = new RegExp(value, options);
        return regexPattern.test(data);
    }
};
//# sourceMappingURL=basic.js.map